
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 12h-4v16h4V12z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M26 12h-4v16h4V12z","fill":"currentColor"}})])
          )
        }
      }
    